import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import "./SearchPage.scss";

const SearchPageKeyword = (props) => {
  var host = window.location.host;
  var protocol = window.location.protocol;
  return (
    <div className="search-keyword-container">
      <div className="search-label">
        키워드 검색 :{" "}
        <span className="search-count">'{props.searchKeyword?.length}'</span> 건
      </div>
      <table className="search-keyword-table">
        <thead>
          <tr>
            <th> </th>
            <th>매뉴</th>
            <th>문서명</th>
            <th> </th>
          </tr>
        </thead>
        <tbody>
          {props.searchKeyword?.map((item, index) => {
            return (
              <tr key={index}>
                <td>{index}</td>
                <td>
                  {item.path[0]} {">"} {item.path[1]}
                </td>
                <td>
                  <Link
                    to={`${protocol}//${host}/${props.basePath}${item.url}`}
                  >
                    <span className="search-keyword-table-title">
                      <Highlighter
                        highlightClassName="search-highlight"
                        searchWords={[props.value] ?? ""}
                        autoEscape={true}
                        textToHighlight={item.title ?? ""}
                      />
                    </span>
                  </Link>
                </td>
                <td></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default SearchPageKeyword;
